import React from 'react';
import './Skills.css';
import { useLanguage } from '../../i18n/LanguageContext';
import { useTheme } from '../../contexts/ThemeContext';

// Importar iconos de tecnologías
import imgIconJavscript from '../../../assets/skills/icon-javscript.svg';
import imgIconTypescript from '../../../assets/skills/icon-typescript.svg';
import imgIconReact from '../../../assets/skills/icon-react.svg';
import imgAngular17 from '../../../assets/skills/angular17.svg';
import imgIconNodejs from '../../../assets/skills/icon-nodejs.svg';
import imgPython from '../../../assets/skills/python.svg';
import imgFlask from '../../../assets/skills/flask.svg';
import imgFlutter from '../../../assets/skills/flutter.svg';
import imgLaravel from '../../../assets/skills/laravel.svg';
import imgDocker from '../../../assets/skills/docker.svg';
import imgIconPostgresql from '../../../assets/skills/icon-postgresql.svg';
import imgIconMongodb from '../../../assets/skills/icon-mongodb.svg';
import imgFrame123 from '../../../assets/skills/n8n.svg';
import imgAws from '../../../assets/skills/aws.svg';
import imgIconFigma from '../../../assets/skills/icon-figma.svg';
import imgOpenai from '../../../assets/skills/openai.svg';
import imgGroup from '../../../assets/skills/huggingface.svg';
import imgGithub from '../../../assets/skills/github.svg';

// iconos tema dark
import imgAwsDark from '../../../assets/skills/awsDark.svg';
import imgFlaskDark from '../../../assets/skills/flaskDark.svg';
import imgGithubDark from '../../../assets/skills/githubDark.svg';
import imgOpenaiDark from '../../../assets/skills/openaiDark.svg';

const getSkillsRow1 = (theme) => [
  { name: 'Javascript', icon: imgIconJavscript },
  { name: 'Typescript', icon: imgIconTypescript },
  { name: 'React', icon: imgIconReact },
  { name: 'Angular', icon: imgAngular17 },
  { name: 'Node.js', icon: imgIconNodejs },
  { name: 'Python', icon: imgPython },
  { name: 'Flask', icon: theme === 'dark' ? imgFlaskDark : imgFlask },
  { name: 'Flutter', icon: imgFlutter },
  { name: 'Laravel', icon: imgLaravel },
];

const getSkillsRow2 = (theme) => [
  { name: 'Docker', icon: imgDocker },
  { name: 'PostgreSQL', icon: imgIconPostgresql },
  { name: 'MongoDB', icon: imgIconMongodb },
  { name: 'n8n queue', icon: imgFrame123 },
  { name: 'AWS', icon: theme === 'dark' ? imgAwsDark : imgAws },
  { name: 'Figma', icon: imgIconFigma },
  { name: 'OpenAI', icon: theme === 'dark' ? imgOpenaiDark : imgOpenai },
  { name: 'Huggingface', icon: imgGroup },
  { name: 'Github', icon: theme === 'dark' ? imgGithubDark : imgGithub },
];

const TechSkill = ({ name, icon }) => (
  <div className="skills__tech" data-name="Tech">
    <div className="skills__tech-icon">
      <img src={icon} alt={name} className="skills__tech-img" />
    </div>
    <p className="skills__tech-name">{name}</p>
  </div>
);

const Skills = () => {
  const { t } = useLanguage();
  const { theme } = useTheme();

  const skillsRow1 = getSkillsRow1(theme);
  const skillsRow2 = getSkillsRow2(theme);

  return (
    <section className="skills" data-name="Skills" data-node-id="5:462">
      <div className="skills__container" data-name="Container" data-node-id="5:463">
        {/* Header */}
        <div className="skills__header" data-name="Row" data-node-id="5:464">
          <div className="skills__header-inner" data-name="Row" data-node-id="5:465">
            <div className="skills__tag" data-name="Tag" data-node-id="5:466">
              <p className="skills__tag-text">{t('skills.tag')}</p>
            </div>
          </div>

          <div className="skills__header-subtitle" data-name="Row" data-node-id="5:467">
            <p className="skills__subtitle" data-node-id="5:468">
              {t('skills.subtitle')}
            </p>
          </div>
        </div>

        {/* Skills Grid */}
        <div className="skills__content" data-name="Row" data-node-id="5:469">
          {/* First Row */}
          <div className="skills__row" data-name="Row" data-node-id="5:470">
            {skillsRow1.map((skill) => (
              <TechSkill key={skill.name} name={skill.name} icon={skill.icon} />
            ))}
          </div>

          {/* Second Row */}
          <div className="skills__row" data-name="Row" data-node-id="5:516">
            {skillsRow2.map((skill) => (
              <TechSkill key={skill.name} name={skill.name} icon={skill.icon} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
